// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"683a17bc","641":"2dafa75e"}[chunkId] + ".chunk.js";
};